import { useMutation, useQuery } from "@tanstack/react-query";
import { useTolgee } from "@tolgee/react";
import axios from "../axios";
import useAppState from "../store/appState";

const fetchCertificates = async ({ seriesId, language, companyId }) => {
  const response = await axios.get("/materials/certificates", {
    params: { seriesId, language, companyId },
  });
  return response.data;
};

const generateCertificate = async ({ seriesId, language, companyId, nameOfCertificate, idTipoDocumental, templateId, documentClass }) => {
  const response = await axios.get("/materials/certificates/generate", {
    params: { series: seriesId, language, keyCompany: companyId, nameOfCertificate, idTipoDocumental, templateId, documentClass },
    responseType: "blob",
  });
  return response.data;
};

export const useCertificates = ({ seriesId, companyId }) => {
  const tolgee = useTolgee(["language"]);
  const { supportedLanguages } = useAppState();

  function getLanguageKey() {
    var languageCode = tolgee.getLanguage();
    return supportedLanguages.find((l) => l.languageCode == languageCode)?.languageNumber ?? 0;
  }

  const language = getLanguageKey();

  const query = useQuery({
    queryKey: ["certificates", seriesId, language, companyId],
    queryFn: () => fetchCertificates({ seriesId, language, companyId }),
    enabled: !!seriesId && !!companyId,
  });

  const mutation = useMutation({
    mutationFn: generateCertificate,
    // onSuccess: (data, params) => {
    //   const pdfBytes = data;

    //   const blob = new Blob([new Uint8Array(pdfBytes)], { type: "application/pdf" });
    //   const url = window.URL.createObjectURL(blob);

    //   const link = document.createElement("a");
    //   link.href = url;

    //   link.download = `${params.nameOfCertificate ?? "certificate"}.pdf`;

    //   document.body.appendChild(link);
    //   link.click();

    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    // },
  });

  return {
    ...query,
    generate: ({ nameOfCertificate, idTipoDocumental, templateId, documentClass, ...params }) =>
      mutation.mutateAsync({
        seriesId,
        language,
        companyId,
        nameOfCertificate,
        idTipoDocumental,
        templateId,
        documentClass,
        ...params,
      }),
  };
};
